import tokens from '@qkindex/design-tokens';

// A shared light source keeps raised and recessed surfaces consistent.
export const surfaceShadows = tokens.shadow;

export const dialogPaperSurface = {
  border: 0,
  boxShadow: '3px 3px 8px rgba(58, 62, 47, 0.16)',
};
